import React, { useState } from "react";

import { PRODUCT_STORE_SECTIONS } from "./ProductStore.catalog";
import { ProductStoreFeatured } from "./ProductStoreFeatured";
import { ProductStoreFilters } from "./ProductStoreFilters";
import { ProductStoreSection } from "./ProductStoreSection";
import {
  ProductStoreAction,
  ProductStoreCategory,
  ProductStorePricing,
} from "./ProductStore.types";

interface Props {
  pricing: ProductStorePricing;
  openingProductType?: string;
  onAction: (action: ProductStoreAction) => void;
}

export const ProductStoreCatalog = ({
  pricing,
  openingProductType,
  onAction,
}: Props) => {
  const [selectedCategory, setSelectedCategory] =
    useState<ProductStoreCategory>("all");
  const visibleSections =
    selectedCategory === "all"
      ? PRODUCT_STORE_SECTIONS
      : PRODUCT_STORE_SECTIONS.filter(
          (section) => section.id === selectedCategory
        );
  const showFeatured =
    selectedCategory === "all" || selectedCategory === "room-panels";

  return (
    <>
      <ProductStoreFilters
        selected={selectedCategory}
        onChange={setSelectedCategory}
      />
      <div id="product-store-results" className="ProductStoreCatalog">
        {showFeatured && (
          <ProductStoreFeatured
            pricing={pricing}
            openingProductType={openingProductType}
            onAction={onAction}
          />
        )}
        <div className="ProductStoreCatalog__sections">
          {visibleSections.map((section) => (
            <ProductStoreSection
              section={section}
              pricing={pricing}
              openingProductType={openingProductType}
              onAction={onAction}
              key={section.id}
            />
          ))}
        </div>
      </div>
    </>
  );
};
